// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1G9Vm","legacyBtn":"MutateMid_legacyBtn__JEJG6"};